/** Sent on window when a page asked for a Method, run or comparison that is in another of the person's workspaces. */
export const OTHER_WORKSPACE_EVENT = "method:other-workspace";
